const locationsIt = [
  {
    "id": 29508,
    "city": "Amman",
    "address": "",
    "code": "AMM",
    "value": "AMM",
    "destination_translations": "",
    "language": "it",
    "country": "Iordania"
  },
  {
    "id": 29501,
    "city": "Amsterdam",
    "address": "",
    "code": "AMS",
    "value": "AMS",
    "destination_translations": "",
    "language": "it",
    "country": "Olanda"
  },
  {
    "id": 29492,
    "city": "Ankara",
    "address": "",
    "code": "ESB",
    "value": "ESB",
    "destination_translations": "",
    "language": "it",
    "country": "Turcia"
  },
  {
    "id": 29483,
    "city": "Antalya",
    "address": "",
    "code": "AYT",
    "value": "AYT",
    "destination_translations": "",
    "language": "it",
    "country": "Turcia"
  },
  {
    "id": 29476,
    "city": "Atena",
    "address": "",
    "code": "ATH",
    "value": "ATH",
    "destination_translations": "",
    "language": "it",
    "country": "Grecia"
  },
  {
    "id": 29469,
    "city": "Barcelona",
    "address": "",
    "code": "BCN",
    "value": "BCN",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 29462,
    "city": "Bari",
    "address": "",
    "code": "BRI",
    "value": "BRI",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29454,
    "city": "Beirut",
    "address": "",
    "code": "BEY",
    "value": "BEY",
    "destination_translations": "",
    "language": "it",
    "country": "Líbano"
  },
  {
    "id": 29444,
    "city": "Belgrad",
    "address": "",
    "code": "BEG",
    "value": "BEG",
    "destination_translations": "",
    "language": "it",
    "country": "Serbia"
  },
  {
    "id": 29431,
    "city": "Bilbao",
    "address": "",
    "code": "BIO",
    "value": "BIO",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 29420,
    "city": "Bodrum",
    "address": "",
    "code": "BJV",
    "value": "BJV",
    "destination_translations": "",
    "language": "it",
    "country": "Turcia"
  },
  {
    "id": 29413,
    "city": "Bologna",
    "address": "",
    "code": "BLQ",
    "value": "BLQ",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29403,
    "city": "Brindisi",
    "address": "",
    "code": "BDS",
    "value": "BDS",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29396,
    "city": "Bruxelles",
    "address": "",
    "code": "BRU",
    "value": "BRU",
    "destination_translations": "",
    "language": "it",
    "country": "Belgia"
  },
  {
    "id": 29387,
    "city": "Bucuresti",
    "address": "",
    "code": "OTP",
    "value": "OTP",
    "destination_translations": "București\nBucuresti\nBucharest\nBucarest\nBukarest\nHenri Coanda\nHenri Coandă\nRoumanie\nRomânia\nRomania",
    "language": "it",
    "country": "România"
  },
  {
    "id": 29378,
    "city": "Budapesta",
    "address": "",
    "code": "BUD",
    "value": "BUD",
    "destination_translations": "",
    "language": "it",
    "country": "Ungaria"
  },
  {
    "id": 29360,
    "city": "Cairo",
    "address": "",
    "code": "CAI",
    "value": "CAI",
    "destination_translations": "",
    "language": "it",
    "country": "Egipt"
  },
  {
    "id": 29351,
    "city": "Catania",
    "address": "",
    "code": "CTA",
    "value": "CTA",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  // {
  //   "id": 29344,
  //   "city": "Chisinau",
  //   "address": "",
  //   "code": "KIV",
  //   "value": "KIV",
  //   "destination_translations": "",
  //   "language": "it",
  //   "country": "Moldavia"
  // },
  {
    "id": 29337,
    "city": "Cluj-Napoca",
    "address": "",
    "code": "CLJ",
    "value": "CLJ",
    "destination_translations": "",
    "language": "it",
    "country": "România"
  },
  {
    "id": 29323,
    "city": "Detroit",
    "address": "",
    "code": "DTW",
    "value": "DTW",
    "destination_translations": "",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 29313,
    "city": "Frankfurt",
    "address": "",
    "code": "FRA",
    "value": "FRA",
    "destination_translations": "",
    "language": "it",
    "country": "Germania"
  },
  {
    "id": 29303,
    "city": "Genova",
    "address": "",
    "code": "GOA",
    "value": "GOA",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29296,
    "city": "Gran Canaria",
    "address": "",
    "code": "LPA",
    "value": "LPA",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 29289,
    "city": "Iasi",
    "address": "",
    "code": "IAS",
    "value": "IAS",
    "destination_translations": "Iași\nIaşi\nIasi\nRoumanie\nRomânia\nRomania",
    "language": "it",
    "country": "România"
  },
  {
    "id": 29280,
    "city": "Istanbul",
    "address": "",
    "code": "IST",
    "value": "IST",
    "destination_translations": "",
    "language": "it",
    "country": "Turcia"
  },
  {
    "id": 29273,
    "city": "Izmir",
    "address": "",
    "code": "ADB",
    "value": "ADB",
    "destination_translations": "",
    "language": "it",
    "country": "Turcia"
  },
  {
    "id": 29262,
    "city": "Milan",
    "address": "",
    "code": "LIN",
    "value": "LIN",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29257,
    "city": "Lisabona",
    "address": "",
    "code": "LIS",
    "value": "LIS",
    "destination_translations": "",
    "language": "it",
    "country": "Portugalia"
  },
  {
    "id": 29252,
    "city": "Londra",
    "address": "",
    "code": "LHR",
    "value": "LHR",
    "destination_translations": "",
    "language": "it",
    "country": "Regatul Unit"
  },
  {
    "id": 29246,
    "city": "Lyon",
    "address": "",
    "code": "LYS",
    "value": "LYS",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29241,
    "city": "Madrid",
    "address": "",
    "code": "MAD",
    "value": "MAD",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 29236,
    "city": "Malaga",
    "address": "",
    "code": "AGP",
    "value": "AGP",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 29231,
    "city": "Marsilia",
    "address": "",
    "code": "MRS",
    "value": "MRS",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29226,
    "city": "Montpellier",
    "address": "",
    "code": "MPL",
    "value": "MPL",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29211,
    "city": "Napoli",
    "address": "",
    "code": "NAP",
    "value": "NAP",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29201,
    "city": "Nisa",
    "address": "",
    "code": "NCE",
    "value": "NCE",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29196,
    "city": "Oradea",
    "address": "",
    "code": "OMR",
    "value": "OMR",
    "destination_translations": "",
    "language": "it",
    "country": "România"
  },
  {
    "id": 29191,
    "city": "Palermo",
    "address": "",
    "code": "PMO",
    "value": "PMO",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29186,
    "city": "Palma de Mallorca",
    "address": "",
    "code": "PMI",
    "value": "PMI",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 29181,
    "city": "Paris",
    "address": "",
    "code": "CDG",
    "value": "CDG",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29176,
    "city": "Pau",
    "address": "Pau Pyrénées Airport",
    "code": "PUF",
    "value": "PUF",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29171,
    "city": "Praga",
    "address": "",
    "code": "PRG",
    "value": "PRG",
    "destination_translations": "",
    "language": "it",
    "country": "Cehia"
  },
  {
    "id": 29166,
    "city": "Riad",
    "address": "",
    "code": "RUH",
    "value": "RUH",
    "destination_translations": "",
    "language": "it",
    "country": "Arabia Saudită"
  },
  {
    "id": 29161,
    "city": "Riga",
    "address": "",
    "code": "RIX",
    "value": "RIX",
    "destination_translations": "",
    "language": "it",
    "country": "Lettonia"
  },
  {
    "id": 29156,
    "city": "Roma",
    "address": "",
    "code": "FCO",
    "value": "FCO",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29151,
    "city": "Salonic",
    "address": "",
    "code": "SKG",
    "value": "SKG",
    "destination_translations": "",
    "language": "it",
    "country": "Grecia"
  },
  {
    "id": 29141,
    "city": "Sofia",
    "address": "",
    "code": "SOF",
    "value": "SOF",
    "destination_translations": "",
    "language": "it",
    "country": "Bulgaria"
  },
  {
    "id": 29136,
    "city": "Strasbourg",
    "address": "",
    "code": "SXB",
    "value": "SXB",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29131,
    "city": "Suceava",
    "address": "",
    "code": "SCV",
    "value": "SCV",
    "destination_translations": "",
    "language": "it",
    "country": "România"
  },
  {
    "id": 29126,
    "city": "Tallin",
    "address": "",
    "code": "TLL",
    "value": "TLL",
    "destination_translations": "",
    "language": "it",
    "country": "Estonia"
  },
  {
    "id": 29121,
    "city": "Tampere",
    "address": "",
    "code": "TMP",
    "value": "TMP",
    "destination_translations": "",
    "language": "it",
    "country": "Finlanda"
  },
  {
    "id": 29116,
    "city": "Tel Aviv",
    "address": "",
    "code": "TLV",
    "value": "TLV",
    "destination_translations": "",
    "language": "it",
    "country": "Israele"
  },
  {
    "id": 29111,
    "city": "Tenerife",
    "address": "",
    "code": "TFN",
    "value": "TFN",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 29106,
    "city": "Timisoara",
    "address": "",
    "code": "TSR",
    "value": "TSR",
    "destination_translations": "",
    "language": "it",
    "country": "România"
  },
  {
    "id": 29101,
    "city": "Torino",
    "address": "",
    "code": "TRN",
    "value": "TRN",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29096,
    "city": "Toulouse",
    "address": "",
    "code": "TLS",
    "value": "TLS",
    "destination_translations": "",
    "language": "it",
    "country": "Franța"
  },
  {
    "id": 29086,
    "city": "Venetia",
    "address": "",
    "code": "VCE",
    "value": "VCE",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 29081,
    "city": "Viena",
    "address": "",
    "code": "VIE",
    "value": "VIE",
    "destination_translations": "",
    "language": "it",
    "country": "Austria"
  },
  {
    "id": 29076,
    "city": "Vilnius",
    "address": "",
    "code": "VNO",
    "value": "VNO",
    "destination_translations": "",
    "language": "it",
    "country": "Lituania"
  },
  {
    "id": 29060,
    "city": "Washington",
    "address": "",
    "code": "IAD",
    "value": "IAD",
    "destination_translations": "",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 29069,
    "city": "Baia Mare",
    "address": "",
    "code": "BAY",
    "value": "BAY",
    "destination_translations": "",
    "language": "it",
    "country": "România"
  },
  {
    "id": 45609,
    "city": "A Coruna",
    "address": "A Coruna Airport",
    "code": "LCG",
    "value": "LCG",
    "destination_translations": "La Coruna\nLa Coruña\nA Coruña\nA Coruña Airport\nA Coruña Airport",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 34309,
    "city": "New York",
    "address": "",
    "code": "JFK",
    "value": "JFK",
    "destination_translations": "",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 32947,
    "city": "Tirana",
    "address": "Aeroporto Internazionale di Tirana Nënë Tereza",
    "code": "TIA",
    "value": "TIA",
    "destination_translations": "Tirana\nTiranë\nRinas\nAlbania\nShqipëri",
    "language": "it",
    "country": "Albania"
  },
  {
    "id": 44865,
    "city": "Dublin",
    "address": "Dublin Airport",
    "code": "DUB",
    "value": "DUB",
    "destination_translations": "",
    "language": "it",
    "country": "Irlanda"
  },
  {
    "id": 44873,
    "city": "Copenhaga",
    "address": "Copenhagen Airport",
    "code": "CPH",
    "value": "CPH",
    "destination_translations": "",
    "language": "it",
    "country": "Danemarca"
  },
  {
    "id": 44880,
    "city": "Gothenburg",
    "address": "Göteborg Landvetter Airport",
    "code": "GOT",
    "value": "GOT",
    "destination_translations": "",
    "language": "it",
    "country": "Suedia"
  },
  {
    "id": 44887,
    "city": "Stockholm",
    "address": "Stockholm Arlanda Airport",
    "code": "ARN",
    "value": "ARN",
    "destination_translations": "",
    "language": "it",
    "country": "Suedia"
  },
  {
    "id": 45586,
    "city": "Florenta",
    "address": "Amerigo Vespucci Airport",
    "code": "FLR",
    "value": "FLR",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 45597,
    "city": "Reggio Calabria",
    "address": "Reggio Calabria Airport",
    "code": "REG",
    "value": "REG",
    "destination_translations": "",
    "language": "it",
    "country": "Italia"
  },
  {
    "id": 45603,
    "city": "Porto",
    "address": "Francisco Sá Carneiro Airport",
    "code": "OPO",
    "value": "OPO",
    "destination_translations": "",
    "language": "it",
    "country": "Portugalia"
  },
  {
    "id": 45615,
    "city": "Vigo",
    "address": "Vigo Airport",
    "code": "VGO",
    "value": "VGO",
    "destination_translations": "",
    "language": "it",
    "country": "Spania"
  },
  {
    "id": 45606,
    "city": "Parigi",
    "address": "Aeroporto di Parigi Orly",
    "code": "ORY",
    "value": "ORY", 
    "destination_translations": "",
    "language": "it",
    "country": "Francia"
  },
  {
    "id": 45607,
    "city": "Chișinău",
    "address": "Aeroporto Internazionale di Chișinău",
    "code": "RMO",
    "value": "RMO",
    "destination_translations": "",
    "language": "it",
    "country": "Moldavia"
  },
  {
    "id": 46001,
    "city": "Calgary",
    "address": "Aeroporto Internazionale di Calgary",
    "code": "YYC",
    "value": "YYC",
    "destination_translations": "Calgary\nCalgary Airport\nCanada",
    "language": "it",
    "country": "Canada"
  },
  {
    "id": 46002,
    "city": "Toronto",
    "address": "Aeroporto Internazionale di Toronto-Pearson",
    "code": "YYZ",
    "value": "YYZ",
    "destination_translations": "Toronto\nToronto Pearson\nPearson\nCanada",
    "language": "it",
    "country": "Canada"
  },
  {
    "id": 46003,
    "city": "Vancouver",
    "address": "Aeroporto Internazionale di Vancouver",
    "code": "YVR",
    "value": "YVR",
    "destination_translations": "Vancouver\nVancouver Airport\nCanada",
    "language": "it",
    "country": "Canada"
  },
  {
    "id": 46004,
    "city": "Boston",
    "address": "Aeroporto Internazionale di Boston-Logan",
    "code": "BOS",
    "value": "BOS",
    "destination_translations": "Boston\nLogan\nBoston Airport\nUnited States\nUSA",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 46005,
    "city": "Las Vegas",
    "address": "Aeroporto Internazionale Harry Reid",
    "code": "LAS",
    "value": "LAS",
    "destination_translations": "Las Vegas\nHarry Reid\nMcCarran\nUnited States\nUSA",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 46006,
    "city": "Los Angeles",
    "address": "Aeroporto Internazionale di Los Angeles",
    "code": "LAX",
    "value": "LAX",
    "destination_translations": "Los Angeles\nLAX\nUnited States\nUSA",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 46007,
    "city": "Seattle",
    "address": "Aeroporto Internazionale di Seattle-Tacoma",
    "code": "SEA",
    "value": "SEA",
    "destination_translations": "Seattle\nSeattle-Tacoma\nSeaTac\nUnited States\nUSA",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 46008,
    "city": "San Francisco",
    "address": "Aeroporto Internazionale di San Francisco",
    "code": "SFO",
    "value": "SFO",
    "destination_translations": "San Francisco\nSFO\nUnited States\nUSA",
    "language": "it",
    "country": "Statele Unite"
  },
  {
    "id": 46009,
    "city": "Anchorage",
    "address": "Aeroporto Internazionale di Anchorage-Ted Stevens",
    "code": "ANC",
    "value": "ANC",
    "destination_translations": "Anchorage\nTed Stevens\nAlaska\nUnited States\nUSA",
    "language": "it",
    "country": "Statele Unite"
  }
];

export default locationsIt;